import React from 'react';

import { AdaptiveCarouselImage } from '@vp/swan';

import { Image } from '../domain/Image';
import { useResponsiveCloudinaryImage } from '../libs/useResponsiveCloudinaryImage';

export interface GalleryImageProps {
  image: Image;
  alt: string;
}

export const GalleryImage: React.FC<GalleryImageProps> = React.memo((props) => {
  const { src, srcSet } = useResponsiveCloudinaryImage(props.image.gallery);

  return (
    <AdaptiveCarouselImage
      aspectRatio="1"
      objectFit="contain"
      src={src}
      srcSet={srcSet}
      alt={props.alt}
    />
  );
});
